import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import API from "../../services/api";
import { toast } from "react-toastify";
import { ApiEndPoint, StatusCode } from "../../services/helper";
import { v4 as uuidv4 } from "uuid";
const storedAccessToken = localStorage?.getItem("accessToken") || null;
const storedRefreshToken = localStorage?.getItem("refreshToken") || null;
const userRole = localStorage?.getItem("role") || null;
// Logged-in distributor's own id (returned by web_login as user_id). Persisted
// so the dashboard can build the end-user invitation link (/invite?distributorId=).
const storedUserId = localStorage?.getItem("userId") || null;
const initialState = {
  userData: null,
  access_token: storedAccessToken,
  refresh_token: storedRefreshToken,
  role: userRole,
  user_id: storedUserId,
  deviceId: "",
};

const { AUTHUSER } = ApiEndPoint;
export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setAuthUser: (state, action) => {
      const currentDeviceId = uuidv4();
      state.access_token = action.payload?.access_token;
      state.role = action.payload?.role;
      state.refresh_token = action.payload?.refresh_token;
      state.deviceId = currentDeviceId;
      state.user_id = action.payload?.user_id;
      localStorage.setItem("accessToken", action.payload?.access_token);
      localStorage.setItem("refreshToken", action.payload?.refresh_token);
      localStorage.setItem("role", action.payload?.role);
      if (action.payload?.user_id) {
        localStorage.setItem("userId", action.payload?.user_id);
      }
    },

    clearAuthUser: (state) => {
      state.access_token = null;
      state.refresh_token = null;
      state.role = null;
      localStorage.clear();
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(authUser.pending, (state, action) => {
        state.status = StatusCode.LOADING;
      })
      .addCase(authUser.fulfilled, (state, action) => {
        state.userData = action.payload;
        state.status = StatusCode.IDLE;
      })
      .addCase(authUser.rejected, (state, action) => {
        state.status = StatusCode.ERROR;
      });
  },
});
export const { setAuthUser, clearAuthUser } = authSlice.actions;
export default authSlice.reducer;
export const authUser = createAsyncThunk("auth/user", async () => {
  try {
    const res = await API.get(`${AUTHUSER}`);
    if (res.status === 200) {
      const result = res.data?.data?.user_details;
      return result;
    }
  } catch (error) {
    toast.error(error.message);
  }
});
